import { create } from 'zustand'
import React from "react";

interface ModalOptions {
    child?: React.ReactNode
    showModal?: boolean
    onReset?: () => void
}

interface ModalStore extends ModalOptions {
    child?: React.ReactNode
    reset: () => void,
    setActiveModal: (child: React.ReactNode) => void
}

export const useModalStore = create<ModalStore>((set, get) => ({
    showModal: false,
    reset: () => {
        set(state => ({
            ...state,
            child: undefined,
            showModal: false
        }))
        // @ts-ignore
        get().onReset && get().onReset()
    },
    setActiveModal: (child: React.ReactNode) => {
        set(state => ({
            ...state,
            child,
            showModal: true
        }))
    }
}))
